'use client';
import React, { useContext } from 'react';
import { MessageFormat, CurrencyFormat, DisplayNames, PhoneNumberFormat, AddressFormat, ExampleGenerator, DateTimeFormat, DateInputMaskFormat } from '@paypalcorp/worldready';
import { Context } from '@paypalcorp/worldready-react';
import { IntlProvider } from '@paypalcorp/pp-react-intl';

var WorldReadyProvider = function (_ref) {
  var worldReady = _ref.worldReady,
    children = _ref.children;
  var worldReadObjFromContext = useContext(Context);
  var worldReadyObj = worldReady || worldReadObjFromContext;
  var intlProviderProps = {
    locale: worldReadyObj.locale,
    messageFormatter: function messageFormatter() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new MessageFormat(worldReadyObj, options);
    },
    currencyFormatter: function currencyFormatter() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new CurrencyFormat(worldReadyObj, options);
    },
    getDisplayNamesObject: function getDisplayNamesObject() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new DisplayNames(worldReadyObj, options);
    },
    phoneFormatter: function phoneFormatter() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new PhoneNumberFormat(options);
    },
    addressFormatter: function addressFormatter() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new AddressFormat(worldReadyObj, options);
    },
    exampleGenerator: function exampleGenerator() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new ExampleGenerator(options);
    },
    dateTimeFormatter: function dateTimeFormatter() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new DateTimeFormat(worldReadyObj, options);
    },
    dateInputMaskFormat: function dateInputMaskFormat() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new DateInputMaskFormat(worldReadyObj, options);
    },
    worldReadyObj: worldReadyObj
  };
  return /*#__PURE__*/React.createElement(IntlProvider, intlProviderProps, children);
};

export { WorldReadyProvider };
